import { render, staticRenderFns } from "./ConvenientlyPurchase.vue?vue&type=template&id=6bbce264&scoped=true&"
import script from "./ConvenientlyPurchase.vue?vue&type=script&lang=js&"
export * from "./ConvenientlyPurchase.vue?vue&type=script&lang=js&"
import style0 from "./ConvenientlyPurchase.vue?vue&type=style&index=0&id=6bbce264&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbce264",
  null
  
)

export default component.exports